import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CardLoaderModule, WidgetsModule } from '@iot-platform/iot-platform-ui';
import { HighchartsChartComponent } from 'highcharts-angular';
import { DashboardsShellComponent } from './containers/dashboards-shell/dashboards-shell.component';

@NgModule({
  imports: [CommonModule, DragDropModule, WidgetsModule, HighchartsChartComponent, CardLoaderModule, DashboardsShellComponent],
  exports: [DashboardsShellComponent]
})
export class IotPlatformDashboardsModule {}
